import { createAPI } from '../http'
import axios from "axios";
import { API_SVC_HOST } from '../../config/common';
axios.create({
    baseURL: API_SVC_HOST
});
const api = createAPI();

/***
 * dashboard api
 */

// 产品性能
export function getDashboardPerformance_comparison(parmas) {
    return api.get('/api/dashboard/performance_comparison', parmas)
}
//加权排名

export function getDashboardWeighted_ranking(parmas) {
    return api.post('/api/dashboard/weighted_ranking', parmas)
}

// 数字护照
export function getDashboardDigital_passport(parmas) {
    return api.get('/api/dashboard/digital_passport', parmas)
}

// 数字护照-产品列表
export function getDashboardDigital_passport_database(parmas) {
    return api.get('/api/dashboard/digital_passport/database', parmas)
}

// 指标-指标列表
export function getDashboardIndex_standard_list(parmas) {
    return api.get('/api/dashboard/digital_passport/index_standard', parmas)
}

// 指标-雷达图
export function getDashboardIndex_radar_map(parmas) {
    return api.get('/api/dashboard/digital_passport/radar_map', parmas)
}

// 指标-指标详情
// 指标
export function getDashboardIndex_standard(parmas) {
    return api.get('/api/dashboard/index_standard', parmas)
}

// 获取产品线信息
export function getDashboardIndex_standard_production_line(parmas) {
    return api.get('/api/dashboard/index_standard/production_line', parmas)
}

// 获取检测机构信息
export function getDashboardIndex_standard_testing_company(parmas) {
    return api.get('/api/dashboard/index_standard/testing_company', parmas)
}

// 获取产品线信息
export function getDashboardIndex_standard_company(parmas) { 
    return api.get('/api/dashboard/index_standard/company', parmas)
}
//产品
export function getDashboardProduct(parmas) {
    return api.get('/api/dashboard/product', parmas)
}
//认证机构
export function getDashboardCertification_body(parmas) {
    return api.get('/api/dashboard/certification_body', parmas)
}

// 获取dashboard产品详情 信息会比产品的详情少一些
export function get_dashboarddigital_passport_database_detail(parmas) {
    /**
     * @param {string} category_id
     * @param {string} id
     */
    return api.get('/api/dashboard/digital_passport/database_detail', parmas)
}
